import { Accordion, Box, Button, Flex, Modal, Table, theme } from '@energiebespaarders/symbols';
import { Check } from '@phosphor-icons/react';
import ActionButton from '../ActionButton';
import HybridLink from '../HybridLink';
import cookieList from './cookieList.json';
import type { ModalProps } from '@energiebespaarders/symbols/components/Modal';

interface CookieListModalProps extends ModalProps {
  acceptCookies?: () => void;
  declineCookies?: () => void;
}

export interface ICookieCategory {
  title: string;
  description: string;
  cookies: ICookie[];
}

export interface ICookie {
  name: string;
  provider: string;
  purpose: string;
  expires: string;
}

const CookieListModal: React.FC<CookieListModalProps> = ({
  acceptCookies,
  declineCookies,
  ...modalProps
}) => {
  return (
    <Modal title="Cookies - voorkeuren instellen" headerFontSize={5} {...modalProps}>
      <Flex flexDirection="column">
        <Box>
          <p>
            We maken gebruik van eigen cookies en die van derden voor o.a. statistiek- en
            marketingdoeleinden. Je kunt hieronder je voorkeuren aanpassen.
          </p>
          <HybridLink
            to="/privacy"
            onClick={modalProps.onRequestClose}
            style={{ color: theme.colors.grayBlack }}
          >
            <u>Meer weten? Lees ons privacy statement.</u>
          </HybridLink>
        </Box>

        <Flex flexDirection="column" my={2}>
          {cookieList.nl.map((c, i) => (
            <Accordion
              key={`${c.title}-${i}`}
              title={`${c.title} cookies`}
              contentPadding={0}
              baseBgColor="grayLight"
              borderWidth="1px"
              contentBorderColor="grayLight"
              mb={2}
            >
              <Table layout={[2 / 6, 3 / 6, 1 / 6]} fontSize={7} themeColor="grayDarker">
                <Table.Row isHeader cellPadding={1}>
                  <Table.Cell>Naam</Table.Cell>
                  <Table.Cell>Doel</Table.Cell>
                  <Table.Cell>Verloopt na</Table.Cell>
                </Table.Row>
                {c.cookies.map(cookie => (
                  <Table.Row key={cookie.name}>
                    <Table.Cell>{cookie.name}</Table.Cell>
                    <Table.Cell>{cookie.purpose}</Table.Cell>
                    <Table.Cell>{cookie.expires}</Table.Cell>
                  </Table.Row>
                ))}
              </Table>
            </Accordion>
          ))}
        </Flex>

        {acceptCookies && declineCookies && (
          <Flex flexWrap="wrap" mx={-1}>
            <Box width={[1, 1, 1 / 2]} px={1} mb={[1, 1, 0]}>
              <ActionButton fluid onClick={acceptCookies}>
                <Check weight="bold" /> &nbsp; Alle cookies aanvaarden
              </ActionButton>
            </Box>

            <Box width={[1, 1, 1 / 2]} px={1}>
              <Button
                fluid
                onClick={declineCookies}
                style={{ borderRadius: 3 }}
                inverse
                bgColor="grayBlack"
              >
                Alleen noodzakelijke cookies
              </Button>
            </Box>
          </Flex>
        )}
      </Flex>
    </Modal>
  );
};

export default CookieListModal;
